var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycleParkingRequestWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 23.333C27.219 23.3332 27.6668 23.781 27.667 24.333V27.333H30.667C31.2189 27.3332 31.6667 27.7811 31.667 28.333C31.667 28.8163 31.3239 29.2203 30.8682 29.3135L30.667 29.333H27.667V32.333C27.667 32.8852 27.2191 33.3328 26.667 33.333C26.1147 33.333 25.667 32.8853 25.667 32.333V29.333H22.667C22.1147 29.333 21.667 28.8853 21.667 28.333C21.6673 27.781 22.1149 27.333 22.667 27.333H25.667V24.333C25.6672 23.7809 26.1148 23.333 26.667 23.333ZM18.6787 8.33301C22.7822 8.33318 26.1172 11.8129 26.1172 16.0938C26.117 20.3744 22.7821 23.8533 18.6787 23.8535H14.959V29.9473C14.9587 30.8675 14.2123 31.6133 13.292 31.6133H11.667C10.7467 31.6133 10.0002 30.8675 10 29.9473V10C10 9.07953 10.7465 8.33301 11.667 8.33301H18.6787ZM14.959 13.5068V18.6797H18.9268C20.2902 18.6795 21.4061 17.5161 21.4062 16.0938C21.4062 14.6712 20.2903 13.5071 18.9268 13.5068H14.959Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleParkingRequestWhite);
export default __webpack_public_path__ + "static/media/bicycle-parking-request-white.6f01d8382f6f4cc880abb4c0b4c1532a.svg";
export { ForwardRef as ReactComponent };